import BaseApi from './baseApi';
import IAuthentication from '../models/IAuthentication';
import ICompanyExciseTariffSet from '../models/ICompanyExciseTariffSet';

export default class CompanyExciseTariffSetsApi extends BaseApi {
    idUser: string = "";

    constructor() {
        super("dataaccess", "Goods");
        let userFromStorage: IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetCompanyExciseTariffSets(): Promise<ICompanyExciseTariffSet[]> {
        let json: string = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            let tariffSets: ICompanyExciseTariffSet[] = [];
            tariffSets = response.data as ICompanyExciseTariffSet[];
            return tariffSets;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetCompanyExciseTariffSetsByCompany(idCompany: string): Promise<ICompanyExciseTariffSet[]> {
        let json: string = this.getJsonReadByCompany(idCompany);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            let tariffSets: ICompanyExciseTariffSet[] = [];
            tariffSets = response.data as ICompanyExciseTariffSet[];
            return tariffSets;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveCompanyExciseTariffSet(tariffSet: ICompanyExciseTariffSet): Promise<string> {
        const json = this.getJsonSave(tariffSet);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateCompanyExciseTariffSet(tariffSet: ICompanyExciseTariffSet): Promise<boolean> {
        const json = this.getJsonUpdate(tariffSet);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteCompanyExciseTariffSet(id: string): Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(id: string): any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "CompanyExciseTariffSets",
            "conditions": [{
                "Item1": "CompanyExciseTariffSets",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(tariffSet: ICompanyExciseTariffSet): any {
        const json = {
            "fieldsvalues": [{
                "Item1": "IdCompany",
                "Item2": tariffSet.idCompany
            }, {
                "Item1": "Name",
                "Item2": tariffSet.name
            }, {
                "Item1": "ValidFrom",
                "Item2": tariffSet.validFrom
            }, {
                "Item1": "ValidTo",
                "Item2": tariffSet.validTo
            }, {
                "Item1": "IsActive",
                "Item2": tariffSet.isActive
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "CompanyExciseTariffSets"
        };
        return json;
    }

    private getJsonUpdate(tariffSet: ICompanyExciseTariffSet): any {
        const json = {
            "fieldsvalues": [{
                "Item1": "IdCompany",
                "Item2": tariffSet.idCompany
            }, {
                "Item1": "Name",
                "Item2": tariffSet.name
            }, {
                "Item1": "ValidFrom",
                "Item2": tariffSet.validFrom
            }, {
                "Item1": "ValidTo",
                "Item2": tariffSet.validTo
            }, {
                "Item1": "IsActive",
                "Item2": tariffSet.isActive
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "CompanyExciseTariffSets",
            "keyvalue": tariffSet.id
        };
        return json;
    }

    private getJsonRead(): any {
        const json = {
            "fields": [{
                "Item1": "CompanyExciseTariffSets",
                "Item2": "id"
            }, {
                "Item1": "CompanyExciseTariffSets",
                "Item2": "IdCompany"
            }, {
                "Item1": "CompanyExciseTariffSets",
                "Item2": "Name"
            }, {
                "Item1": "CompanyExciseTariffSets",
                "Item2": "ValidFrom"
            }, {
                "Item1": "CompanyExciseTariffSets",
                "Item2": "ValidTo"
            }, {
                "Item1": "CompanyExciseTariffSets",
                "Item2": "IsActive"
            }],
            "tables": [{
                "Item1": "CompanyExciseTariffSets"
            }],
            "conditions": [{
                "Item1": "CompanyExciseTariffSets",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0"
            }],
            "orderBy": [{
                "Item1": "CompanyExciseTariffSets.ValidFrom"
            }]
        };
        return json;
    }

    private getJsonReadByCompany(idCompany: string): any {
        const json = {
            "fields": [{
                "Item1": "CompanyExciseTariffSets",
                "Item2": "id"
            }, {
                "Item1": "CompanyExciseTariffSets",
                "Item2": "IdCompany"
            }, {
                "Item1": "CompanyExciseTariffSets",
                "Item2": "Name"
            }, {
                "Item1": "CompanyExciseTariffSets",
                "Item2": "ValidFrom"
            }, {
                "Item1": "CompanyExciseTariffSets",
                "Item2": "ValidTo"
            }, {
                "Item1": "CompanyExciseTariffSets",
                "Item2": "IsActive"
            }],
            "tables": [{
                "Item1": "CompanyExciseTariffSets"
            }],
            "conditions": [{
                "Item1": "CompanyExciseTariffSets",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "CompanyExciseTariffSets",
                "Item2": "IdCompany",
                "Item3": "=",
                "Item4": idCompany
            }],
            "orderBy": [{
                "Item1": "CompanyExciseTariffSets.ValidFrom"
            }]
        };
        return json;
    }
}
